import Notification from '@serko/zui/es/Notification';
import NotificationContentText from '@serko/zui/es/NotificationContentText/NotificationContentText';
import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import messages from '../../intl/messages';
import { Typography } from '@material-ui/core';

interface OwnProps {
  isSaviSelectIntl: boolean;
}

interface SentToArrangerProps extends OwnProps, InjectedIntlProps {}

const SentToArrangerBase: FunctionComponent<SentToArrangerProps> = ({
  intl: { formatMessage },
  isSaviSelectIntl,
}) => (
  <Notification type="Success">
    <NotificationContentText>
      <Typography variant="subheading">
        {formatMessage(messages.notification.trip.sendToArranger)}
      </Typography>
      {isSaviSelectIntl && (
        <Typography variant="body1">
          {formatMessage(messages.notification.trip.disclaimer)}
        </Typography>
      )}
    </NotificationContentText>
  </Notification>
);

export const SentToArranger = injectIntl(SentToArrangerBase);

SentToArranger.displayName = 'SentToArranger';
